





























import Vue from "vue";
import Component from "vue-class-component";
import {
  Icon,
  CRS,
  latLng,
  latLngBounds,
  LatLngBounds,
  DomUtil,
  LeafletMouseEvent,
  LatLng,
  MapOptions,
} from "leaflet";

import { LMap, LControlScale } from "vue2-leaflet";
//import { maps, features, targets } from "@/store";
import { maps, features } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

//Layers
import TileLayers from "./layers/TileLayers.vue";
import FeaturesLayer from "./layers/FeaturesLayer.vue";
import TargetsLayer from "./layers/TargetsLayer.vue";
import MeasurementLayer from "./layers/MeasurementLayer.vue";

//Controls
import MouseCoordsDisplay from "./controls/MouseCoordsDisplay.vue";
import MeasurementControl from "./controls/MeasurementControl.vue";

type D = Icon.Default & {
  _getIconUrl?: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

@Component<MapComponent>({
  components: {
    LMap,
    TileLayers,
    FeaturesLayer,
    TargetsLayer,
    MeasurementLayer,
    LControlScale,
    MouseCoordsDisplay,
    MeasurementControl,
  },
  watch: {
    measurementActivated: function(newvalue) {
      if (newvalue) {
        DomUtil.addClass(this.map._container, "crosshair-cursor-enabled");
      } else {
        DomUtil.removeClass(this.map._container, "crosshair-cursor-enabled");
      }
    },
  },
})
export default class MapComponent extends Vue {
  //data
  crs: CRS = CRS.EPSG3857;
  map: any = null;
  minZoom: number = 6;
  maxBounds: LatLngBounds = latLngBounds(
    latLng(24.927, -87.814), // abajo izquierda 17.821916, -94.460449
    latLng(17.298, -99.009)   // arriba derecha 21.330315, -89.637451
  );

  mapOptions: MapOptions = {
    zoomSnap: 0.5,
    wheelPxPerZoomLevel: 100,
    scrollWheelZoom: "center",
  };
  mouseCoords: LatLng = latLng(0, 0);

  $refs!: {
    map: any;
  };

  ///computed
  get mapCenter() {
    return maps.getters.mapCenter;
  }
  get mapZoom() {
    return maps.getters.mapZoom;
  }
  get measurementActivated() {
    return maps.getters.measurementActivated;
  }

  get crossHair() {
    return "leaflet-container crosshair-cursor-enabled";
  }

  //methods
  updateZoom(zoom: number) {
    maps.commit(MutationTypes.UPDATE_ZOOM, zoom);
  }
  updateBounds(bounds: LatLngBounds) {
    maps.commit(MutationTypes.UPDATE_BBOX, bounds);
  }
  clickHandler(event: LeafletMouseEvent) {
    if (this.measurementActivated) {
      maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
        tipo: "map",
        data: event.latlng,
      });
    }
  }
  mouseHandler(event: LeafletMouseEvent) {
    this.mouseCoords = event.latlng;
  }

  created() {
    features.dispatch("getPipelines");
    //targets.dispatch("getAtons");
    //targets.dispatch("getBaseStations");
    maps.commit(MutationTypes.UPDATE_BBOX, this.maxBounds);
    this.mouseCoords = this.mapCenter;
  }
  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.map.mapObject;
    });
  }
}
